import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FileUploader } from "../../../../components/FileUploader/FileUploader";
import Axios from "axios";
import moment from "moment";
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { ROUTES } from "../../../../utils/routes";
import Swal from "sweetalert2";
import { paths } from "../../../../utils/paths";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { validate } from "./validations";
import { ArchiveUploader } from "../../../../components/FileUploader/ArchiveUploader";
import { PdfUploader } from "../../../../components/FileUploader/PdfUploader";

export const ManageEjemplares = () => {
  const { EJEMPLARES, PROJECTS, INVESTIGATORS, REVISTAS } = paths;
  const { id } = useParams();
  const { deleteIt } = useDelete();

  let { staffId, isAdmin, userId } = useSelector(({ user }) => user);

  const history = useHistory();

  const [isCreate, setIsCreate] = useState(false);

  const [titulo, setTitulo] = useState("");
  const [estado, setEstado] = useState("");
  const [anyo, setAnyo] = useState("");
  const [archivoBiblioteca, setArchivoBiblioteca] = useState("");
  const [motivoBaja, setMotivoBaja] = useState("");
  const [fechaPrestamo, setFechaPrestamo] = useState("");
  const [staff, setStaff] = useState([]);
  const [usuarioPrestamoId, setUsuarioPrestamoId] = useState("");
  const [revistas, setRevistas] = useState([]);
  const [revistaId, setRevistaId] = useState("");
  const [usuarioPrestamoEmail, setUsuarioPrestamoEmail] = useState("");
  const [numero, setNumero] = useState("");
  const [volumen, setVolumen] = useState("");

  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMountedRef.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? setIsCreate(true) : loadData();
    loadStaticData();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadStaticData = async () => {
    try {
      let staff = isAdmin
        ? await getAll(INVESTIGATORS, source)
        : await getAll(INVESTIGATORS, source);
      let revistas = await getAll(REVISTAS, source);
      isMountedRef.current && isAdmin ? setStaff(staff) : setStaff(staff);
      setRevistas(revistas);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadData = async () => {
    try {
      let response = await getById(EJEMPLARES, id, source);
      isMountedRef.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (response) => {
    let allStaff = isAdmin
      ? await getAll(INVESTIGATORS, source)
      : await getAll(INVESTIGATORS, source);
    let allRevistas = await getAll(REVISTAS, source);
    const startDateWithOffset =
      response.fechaPrestamo && new Date(response.fechaPrestamo);
    const startDateNoOffset =
      startDateWithOffset &&
      new Date(
        startDateWithOffset.getTime() -
          startDateWithOffset.getTimezoneOffset() * -60000
      );
    const {
      titulo,
      estado,
      archivoBiblioteca,
      motivoBaja,
      numero,
      volumen,
      anyo,
    } = response;

    setTitulo(titulo);
    setEstado(estado);
    setMotivoBaja(motivoBaja);
    setFechaPrestamo(startDateNoOffset);
    setNumero(numero);
    setArchivoBiblioteca(archivoBiblioteca);
    setVolumen(volumen);
    setAnyo(anyo);

    isAdmin ? setStaff(allStaff) : setStaff(allStaff);
    setRevistas(allRevistas);
    setUsuarioPrestamoId(response.usuarioPrestamo?.id);
    setRevistaId(response.revista?.id);

    const aux = await getById(
      INVESTIGATORS,
      response.usuarioPrestamo?.id,
      source
    );
    setUsuarioPrestamoEmail(aux?.email_personal);

    if (isMountedRef.current) setAllowedEdit(true);
  };

  const handleSubmit = () => {
    const ejemplares = build();
    // const notValid = validate(ejemplares);
    // if (notValid) {
    //   setMessage(notValid);
    //   setTimeout(() => setMessage(""), 4000);
    //   return;
    // }
    let question = isCreate ? "crear un" : "editar este";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} ejemplar?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => {
      isConfirmed && handleConfirmation(ejemplares);
    });
  };

  const handleConfirmation = (ejemplares) => {
    let createOrUpdate = isCreate
      ? create(EJEMPLARES, ejemplares, source)
      : update(EJEMPLARES, id, ejemplares, source);
    createOrUpdate
      .then(async ({ id }) => {
        if (typeof archivoBiblioteca !== "string") {
          const formData = new FormData();
          formData.append("document", archivoBiblioteca);
          await saveFile(
            EJEMPLARES,
            id,
            "archivo-biblioteca",
            formData,
            source
          );
        }
        Swal.fire({
          icon: "success",
          text: `Ejemplar ${isCreate ? "creado" : "editado"} correctamente.`,
        });
        history.push(`${ROUTES.Biblioteca.all}`);
        setIsCreate(false);
      })
      .catch(() => {
        Swal.fire({
          icon: "error",
          text: SwalError,
        });
      });
  };

  const build = () => ({
    titulo,
    estado,
    motivoBaja,
    fechaPrestamo: moment(fechaPrestamo).format("YYYY-MM-DD"),
    numero,
    volumen,
    anyo,
    usuarioPrestamoId: +usuarioPrestamoId,
    revistaId: +revistaId,
  });

  const exists = isAdmin
    ? staff.some((c) => c.id === usuarioPrestamoId)
    : staff.some((c) => c.id === usuarioPrestamoId);

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Ejemplar
        </button>
      );
    }
    if (!isCreate || isAdmin) {
      return (
        <>
          <button className="baseBtn" onClick={handleSubmit}>
            Guardar cambios
          </button>
          <button
            className="smallBtn btn-danger ml-1"
            onClick={() =>
              deleteIt(EJEMPLARES, id, ROUTES.Biblioteca.all, source)
            }
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      );
    }
  };

  return (
    <div className="centerPage">
      <div className="container-fluid p-4">
        <div className="row">
          <div className="col d-flex justify-summary-between">
            <div>
              <h3>Ejemplares </h3>
            </div>
          </div>
          {<div>{editDeleteButtons()}</div>}
        </div>
        <div className="row mt-4">
          <div className="col-12 text-center text-danger">
            <span>{message}</span>
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>*Título</small>
            <input
              type="text"
              className="form-control"
              placeholder="*Título"
              value={titulo}
              onChange={({ target: { value } }) => {
                setTitulo(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col-6">
            {!isCreate || exists ? (
              <>
                <small>*Usuario préstamo</small>
                <select
                  className="form-control input"
                  value={usuarioPrestamoId}
                  onChange={({ target: { value } }) => {
                    setUsuarioPrestamoId(value);
                  }}
                >
                  <option value={null}>Disponible</option>
                  {staff?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre} {c.apellidos}
                    </option>
                  ))}
                </select>
                {usuarioPrestamoEmail && (
                  <div className="form-row mt-2 ml-2">
                    <a
                      href={`mailto:${usuarioPrestamoEmail}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Enviar un email a: {usuarioPrestamoEmail}
                    </a>
                  </div>
                )}
              </>
            ) : (
              <></>
            )}
          </div>
          {!isCreate && (
            <div className="col">
              <span>Fecha de préstamo</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Fecha de prestamo"
                selected={fechaPrestamo}
                onChange={(date) => setFechaPrestamo(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
                disabled={!allowedEdit}
              />
            </div>
          )}
        </div>
        <div className="form-row mt-2">
          <div className="col   justify-content-center">
            <ArchiveUploader
              handleFile={isAdmin ? setArchivoBiblioteca : ""}
              archive={archivoBiblioteca}
              disable={!allowedEdit}
            />
          </div>
        </div>
        <div className="form-row mt-2">
          {!isCreate && (
            <div className="col">
              <small>Motivo baja</small>
              <select
                className="form-control input"
                value={motivoBaja}
                onChange={({ target: { value } }) => {
                  setMotivoBaja(value);
                }}
                disabled={!isAdmin}
              >
                <option value="">Seleccione una opción</option>
                <option value="Dañado">Dañado</option>
                <option value="Obsolescencia">Obsolescencia</option>
                <option value="Duplicidad">Duplicidad</option>
                <option value="Perdida_O_Robo">Pérdida o robo 2</option>
                <option value="No_Utilizacion">No utilización</option>
              </select>
            </div>
          )}
          <div className="col-6">
            {(!isCreate && isAdmin) || exists ? (
              <>
                <small>Revistas</small>
                <select
                  className="form-control input"
                  value={revistaId}
                  onChange={({ target: { value } }) => {
                    setRevistaId(value);
                  }}
                  disabled={isAdmin}
                >
                  <option value={null}>Seleccione</option>
                  {isAdmin
                    ? revistas?.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.titulo}
                        </option>
                      ))
                    : revistas?.map((c) => (
                        <option key={c?.id} value={c?.id}>
                          {c.titulo}
                        </option>
                      ))}
                </select>
              </>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Número</small>
            <input
              type="text"
              className="form-control"
              placeholder="Numero"
              value={numero}
              onChange={({ target: { value } }) => {
                setNumero(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
        </div>

        <div className="form-row mt-2">
          <div className="col">
            <small>Volumen</small>
            <input
              type="text"
              className="form-control"
              placeholder="Volumen"
              value={volumen}
              onChange={({ target: { value } }) => {
                setVolumen(value);
              }}
              readOnly={!isAdmin}
            />
          </div>

          <div className="col">
            <small>Estado</small>
            <select
              className="form-control input"
              value={estado}
              onChange={({ target: { value } }) => {
                setEstado(value);
              }}
              disabled={!isAdmin}
            >
              <option value="">Seleccione una opción</option>
              <option value="opcion1">Opción 1</option>
              <option value="opcion2">Opción 2</option>
              <option value="opcion3">Opción 3</option>
            </select>
          </div>
        </div>
        <div className="form-row mt-2">
          <div className="col">
            <small>Año</small>
            <input
              type="text"
              className="form-control"
              placeholder="Año"
              value={anyo}
              onChange={({ target: { value } }) => {
                setAnyo(value);
              }}
              readOnly={!isAdmin}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
